// BULK COPY APPLICANTS TO ANOTHER JOB ************************************************************
// pathname: /v3/bulk-operation/copy/{jobSlug}
// ************************************************************************************************
import { useSwrMutationApi, PostBulkCopyApplicants } from 'src/hooks/useSwrApi';


/**
 * @description Copies the selected applicants to another job.
 * - If all applicants are selected, use the 'buildListByStatus' parameter (back-end will ignore the 'slugs' array).
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param successCallback - callback function to be executed on success
 *
 * @example
 * // copy all applicants with status 'interview' (3) to another job
 * const { data, trigger } = useSwrBulkCopyApplicants(jobSlug, 'ro');
 * trigger({ buildListByStatus: 3, destinationJobId: 123, destinationJobTitle: 'Job title' });
 *
 * // copy selected applicants to another job
 * trigger({ slugs: ['slug1', 'slug2'], destinationJobId: 123, destinationJobTitle: 'Job title' });
 */
export const useSwrBulkCopyApplicants = (jobSlug: string, locale: string = 'ro', successCallback?: () => void) => {
  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<undefined, PostBulkCopyApplicants>({
    url: `/v3/bulk-operation/copy/${jobSlug}`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
